import React, { useState, useEffect } from 'react';
import {
    Button,
    CardActions,
    CardContent,
    CardHeader,
    Typography,
} from '@mui/material';
import { DialogCard } from '../../../../../Components';

const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
};

export const LogoutModal = ({ onLogout, timerDuration, onStayLoggedIn }) => {
    const [countdown, setCountdown] = useState(timerDuration);

    useEffect(() => {
        setCountdown(timerDuration);
    }, [timerDuration]);

    useEffect(() => {
        if (countdown <= 0) {
            onLogout();
            return undefined;
        }

        const timer = setInterval(() => {
            setCountdown((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [countdown, onLogout]);

    return (
        <DialogCard>
            <CardHeader title="Session expiring" />
            <CardContent sx={{ p: 2, pt: 0, textAlign: 'center' }}>
                <Typography variant="body2" color="text.secondary">
                    Automatic logout in
                </Typography>
                <Typography variant="h3" sx={{ fontWeight: 600, my: 2 }}>
                    {formatTime(Math.max(0, countdown))}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Would you like to continue your session?
                </Typography>
            </CardContent>
            <CardActions sx={{ justifyContent: 'center' }}>
                <Button variant="contained" color="primary" onClick={onStayLoggedIn}>
                    Stay Logged In
                </Button>
            </CardActions>
        </DialogCard>
    );
};
